const SCAM_PROOF_POCKET_GUIDE_1999_PRODUCT = 'scamProofPocketGuideToStaySafeOnline1999';
const HOW_TO_SHOP_ONLINE_SAFELY_1999_PRODUCT = 'howToShopOnlineSafely1999';
const FULL_DIGITAL_SAFETY_GUIDE_PRODUCT = 'fullDigitalSafetyGuide';
const LIFETIME_LIVE_SUPPORT_2999_PRODUCT = 'lifetimeLiveSupport2999';

export {
    SCAM_PROOF_POCKET_GUIDE_1999_PRODUCT,
    HOW_TO_SHOP_ONLINE_SAFELY_1999_PRODUCT,
    FULL_DIGITAL_SAFETY_GUIDE_PRODUCT,
    LIFETIME_LIVE_SUPPORT_2999_PRODUCT
};
